import React, { useState } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { createGiftLink, getReferrerGiftClaimCount } from "../../../api";
import styles from "./styles.m.css";
import Icon from "../icon";
import { DeepBI } from "../../../integrations";

const sign = require("jwt-encode");

export default function ShareGiftButton({ articleUrl, title, articleId, jwtKey, heroImage, publishedAt, story }) {
  const [showPopup, setShowPopup] = useState(false);
  const [claimCount, setClaimCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);
  const [message, setMessage] = useState("Hi! I’ve gifted you a premium Vikatan story I loved. Hope you enjoy it!");

  const handleShareClick = async () => {
    const user = await global.userPromise.catch(() => ({}));
    if (!user || !user.userId) {
      DeepBI.pingPaywallEventTrigger(story, "ShareGiftButton_SignIn_Required");
      global.showLoginPopup && global.showLoginPopup();
      return;
    }

    DeepBI.pingPaywallEventTrigger(story, "GiftArticleButton_Clicked");

    setIsLoading(true);

    const userId = user.userId;
    // const userId = "3943874"; // Replace with actual user ID in production
    const payload = {
      userId: userId
    };
    const jwtToken = sign(payload, jwtKey);

    const response = await getReferrerGiftClaimCount(userId, jwtToken);
    setIsLoading(false);
    console.log("Gift claim count response:", response);
    const count = get(response, ["claim_count"], 0);
    setClaimCount(count);
    setShowPopup(true);
  };

  const handleClaim = async () => {
    if (claimCount === 0) return;

    try {
      const user = await global.userPromise.catch(() => ({}));
      if (!user || !user.userId) {
        DeepBI.pingPaywallEventTrigger(story, "ShareGiftButton_Claim_SignIn_Required");
        global.showLoginPopup && global.showLoginPopup();
        return;
      }

      DeepBI.pingPaywallEventTrigger(story, "GiftArticle_SendGift_Clicked");

      setIsGenerating(true);
      const userId = user.userId;
      // const userId = "826969"; // Replace with actual user ID in production
      const payload = {
        userId: userId
      };

      const jwtToken = sign(payload, jwtKey);

      const response = await createGiftLink(
        {
          userId: userId,
          articleId: articleId
        },
        jwtToken
      );

      setIsGenerating(false);

      if (response && response.status === "success" && response.gift_id) {
        const shareUrl = `${articleUrl}?giftid=${response.gift_id}`;

        // if (navigator.share) {
        //   DeepBI.pingPaywallEventTrigger(story, "GiftArticle_SendGift_Success");
        //   navigator.share({
        //     title: title || "Gift Article",
        //     text: message ? "🎁 " + message : "🎁 I’m gifting you this article",
        //     url: shareUrl
        //   });
        //   setShowPopup(false);
        //   return;
        // }

        if (navigator.share) {
          DeepBI.pingPaywallEventTrigger(story, "GiftArticle_SendGift_Success");

          const shareText = `Hi! I've gifted you a premium Vikatan story I loved. Hope you enjoy it!

${title ? `“${title}”\n` : ""}

${shareUrl}

Get Unlimited Access to All Vikatan magazine worth ₹250 for FREE.
Install Vikatan APP https://vikatanmobile.page.link/ShareButton`;

          navigator.share({
            title: title || "Gift Article",
            text: shareText
          });

          setShowPopup(false);
          return;
        }

        // Fallback
        DeepBI.pingPaywallEventTrigger(story, "GiftArticle_SendGift_Success_Copy");
        navigator.clipboard.writeText(shareUrl);
        setShowPopup(false);
      } else {
        DeepBI.pingPaywallEventTrigger(story, "GiftArticle_SendGift_Failed");
        console.log(get(response, ["msg"], "Failed to generate gift link."));
      }
    } catch (error) {
      DeepBI.pingPaywallEventTrigger(story, "GiftArticle_SendGift_Error");
      setIsGenerating(false);
      console.error("Error sharing gift:", error);
    }
  };

  return (
    <div className="share-gift-wrapper">
      <button
        type="button"
        onClick={handleShareClick}
        disabled={isLoading}
        className={styles["share-gift-button"]}
        style={{ cursor: isLoading ? "not-allowed" : "pointer" }}
      >
        {isLoading ? (
          <div className={styles["button-content"]}>
            <Icon type="icon-gift" /> <div className={styles["button-text"]}>&quot;Checking...&quot;</div>
          </div>
        ) : (
          <div className={styles["button-content"]}>
            <Icon type="icon-gift" /> <div className={styles["button-text"]}>Gift This Article</div>
          </div>
        )}
      </button>

      {showPopup && (
        <div className={styles["gift-popup-overlay"]}>
          <div className={styles["gift-popup"]}>
            <div className={styles["gift-popup-content"]}>
              <button
                type="button"
                onClick={() => {
                  DeepBI.pingPaywallEventTrigger(story, "GiftArticle_Popup_Closed");
                  setShowPopup(false);
                }}
                className={styles["close-button"]}
              >
                &times;
              </button>
              <div
                className={`${styles["gift-article-header"]} ${
                  claimCount !== 0 ? styles["claimed-header"] : styles["not-claimed-header"]
                }`}
              >
                <img
                  src="https://images.assettype.com/vikatan/2026-03-09/6oul6cxb/gift-article-logo.png?q=100&w=224"
                  alt="Gift Article Logo"
                />
                <div className={styles["gift-icons-container"]}>
                  <div className={styles["gift-icons-credits"]}>
                    {new Date().toLocaleString("default", { month: "short", year: "numeric" })} <br /> Gift Credits
                  </div>
                  <div className={styles["gift-icons"]}>
                    <div className={styles["gift-icons-wrapper"]}>
                      {[...Array(5)].map((_, i) => (
                        <div
                          className={styles["gift-icon"]}
                          key={i}
                          style={{
                            transition: "transform 0.3s ease",
                            transform: i < claimCount ? "scale(0.9)" : "scale(1)",
                            opacity: i < claimCount ? 0.6 : 1
                          }}
                        >
                          {i < claimCount ? <Icon type="icon-gift" /> : <Icon type="icon-gift-open" />}
                          {/* {i < claimCount && (
                            <span className={styles["claimed-badge"]}>
                              <Icon type="icon-gift-open" />
                            </span>
                          )} */}
                        </div>
                      ))}
                    </div>
                    <div>
                      {claimCount}
                      /5 Premium Gifts
                    </div>
                  </div>
                </div>
              </div>
              {claimCount !== 0 && (
                <div>
                  <div className={styles["gift-article-story-header"]}>
                    <div className={styles["gift-article-story-header-content"]}>
                      <img src="https://images.assettype.com/vikatan/2026-03-10/recs4xm9/article-header.png" />
                    </div>
                    <div className={styles["gift-article-story"]}>
                      {heroImage && (
                        <img
                          src={`https://media.vikatan.com/${heroImage}`}
                          alt={title || "Article"}
                          className={styles["gift-article-image"]}
                        />
                      )}
                      <div className={styles["gift-article-content"]}>
                        {title && (
                          <p className={styles["gift-article-headline"]}>
                            &ldquo;
                            {title}
                            &rdquo;
                          </p>
                        )}
                        {publishedAt && <span className={styles["gift-article-date"]}>{publishedAt}</span>}
                        {/* <img
                      src="https://images.assettype.com/vikatan/2024-11/7abd62c8-e534-4e01-a6c4-48a6f3419b79/vikatan_logo.png"
                      alt="Vikatan"
                      className={styles["gift-vikatan-logo"]}
                    /> */}
                      </div>
                    </div>
                    <div className={styles["gift-article-credit-info"]}>This will use 1 Gift Credits</div>
                  </div>

                  <div className={styles["gift-article-message"]}>
                    <h5>Message</h5>
                    <textarea
                      className={styles["gift-article-description"]}
                      value={message}
                      onChange={e => setMessage(e.target.value)}
                      maxLength={100}
                      style={{
                        border: "none",
                        outline: "none",
                        resize: "none",
                        fontFamily: "inherit",
                        boxSizing: "border-box"
                      }}
                      rows={2}
                    />
                    <p className={styles["message-char-limit"]}>
                      {message.length}
                      /100
                    </p>
                  </div>
                </div>
              )}

              {/* <div
                style={{
                  backgroundColor: "#f5f5f5",
                  padding: "15px",
                  borderRadius: "8px",
                  marginBottom: "25px",
                  fontSize: "14px",
                  color: "#444"
                }}
              >
                You have claimed <strong>{claimCount}</strong> out of <strong>5</strong> articles.
              </div> */}

              {claimCount === 0 && (
                <div>
                  <div>
                    <img src="https://images.assettype.com/vikatan/2026-03-27/j6wwb1wy/gift.png" />
                  </div>
                  <p
                    style={{ color: "#fff", fontSize: "13px", marginTop: "15px", fontWeight: "500" }}
                    className={styles["limit-exceed-text"]}
                  >
                    {/* You have reached your maximum limit of 5 gift articles. */}
                    You’ve used all your gift credits for this month. Your gift credits will refresh on 1st of next
                    month.
                  </p>
                </div>
              )}

              <button
                type="button"
                onClick={handleClaim}
                disabled={claimCount === 0 || isGenerating}
                className={styles["claim-button"]}
                style={{
                  backgroundColor: claimCount === 0 ? "#ccc" : "#ff9800",
                  cursor: claimCount === 0 || isGenerating ? "not-allowed" : "pointer"
                }}
              >
                {isGenerating ? "Generating..." : claimCount === 0 ? "Limit Reached" : "Send A Gift"}
              </button>

              {claimCount > 0 &&
                !isGenerating && (
                  <div className={styles["newuser-text"]}>This gift can be claimed by one new user only.</div>
                )}

              <div className={styles["gift-popup-footer"]}>
                <div>
                  <a
                    href="https://www.vikatan.com/how-gift-article-works"
                    onClick={() => DeepBI.pingPaywallEventTrigger(story, "GiftArticle_How_It_Works_Clicked")}
                  >
                    How this works?
                  </a>
                </div>
                {/* <div onClick={() => DeepBI.pingPaywallEventTrigger(story, "GiftArticle_Check_Gifted_Stories_Clicked")}>
                  Check Gifted Stories
                </div> */}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

ShareGiftButton.propTypes = {
  articleUrl: PropTypes.string,
  title: PropTypes.string,
  articleId: PropTypes.string,
  jwtKey: PropTypes.string,
  heroImage: PropTypes.string,
  publishedAt: PropTypes.string,
  story: PropTypes.object
};
